<div class="modal-box modal_box">
  <div class="modal_header bg_primary_light">
    <button type="button" class="btnn close_btn" mat-dialog-close>
      <mat-icon>{{ 'close' | translate }}</mat-icon>
    </button>

    <figure>
      <img [src]="assetsConst.Logo" />
    </figure>
  </div>
  <div class="modal_body">
    <div class="modal_subtitle">
      <h3>{{ 'profileSetup' | translate }}</h3>
    </div>
    <form [formGroup]="profileSetUpFormGroup" (ngSubmit)="onSubmit()">
      <div class="gap_m form_filed">
        <div class="form_group">
          <div class="user_img_wrp">
            <figure class="user_img">
              <img
                [src]="
                  profileSetUpFormGroup.get('image')?.value
                    ? profileSetUpFormGroup.get('image')?.value
                    : assetsConst.placeholderImage
                "
                alt="img" />
            </figure>
            <figure class="camera_icon">
              <mat-icon>{{ 'add' | translate }}</mat-icon>
              <input
                type="file"
                accept="image/*"
                (change)="onFileChange($event)" />
            </figure>
          </div>
          <mat-error
            *ngIf="
              submitted &&
              profileSetUpFormGroup.get('image')?.hasError('required')
            ">
            {{ 'Image' | translate }} {{ 'isRequired' | translate }}
          </mat-error>
        </div>

        <div class="form_group">
          <mat-form-field>
            <input
              matInput
              [placeholder]="'fullName' | translate"
              class="form_control"
              formControlName="name" />
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              profileSetUpFormGroup.get('name')?.hasError('required')
            ">
            {{ 'fullName' | translate }}
            {{ 'isRequired' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              submitted &&
              profileSetUpFormGroup.get('name')?.hasError('maxlength')
            ">
            {{ 'nameUpto40Char' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              submitted &&
              profileSetUpFormGroup.get('name')?.hasError('minlength')
            ">
            {{ 'fullName' | translate }} {{ 'atleast3Char' | translate }}
          </mat-error>
        </div>

        <div class="form_group">
          <mat-form-field>
            <input
              matInput
              [placeholder]="'enterEmail' | translate"
              type="email"
              formControlName="email"
              class="form_control" />
          </mat-form-field>
          <div class="vrfy_btm">
            <div *ngIf="EmailVerify" class="vrfy_tck">
              <span>{{ 'Verified' | translate }}</span>
              <mat-icon>check</mat-icon>
            </div>
            <div
              *ngIf="
                !EmailVerify &&
                profileSetUpFormGroup.get('email')?.value &&
                !profileSetUpFormGroup.get('email')?.hasError('pattern')
              "
              class="only_btn">
              <a (click)="openDialog('email')">
                {{ 'Verify' | translate }}
              </a>
            </div>
          </div>
          <mat-error
            *ngIf="
              submitted &&
              profileSetUpFormGroup.get('email')?.hasError('required')
            ">
            {{ 'email' | translate }}
            {{ 'isRequired' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              submitted &&
              profileSetUpFormGroup.get('email')?.hasError('pattern')
            ">
            {{ 'PleaseEnterValid' | translate }}
            {{ 'email' | translate }}
          </mat-error>
        </div>

        <div class="form_group phone-input">
          <ngx-mat-intl-tel-input
            [preferredCountries]="['ly']"
            name="phone"
            describedBy="phoneInput"
            formControlName="phoneNo"
            #phone
            (countryChanged)="countryChangedEvent($event)">
          </ngx-mat-intl-tel-input>
          <div class="vrfy_btm">
            <div *ngIf="phoneVerify" class="vrfy_tck">
              <span>{{ 'Verified' | translate }}</span>
              <mat-icon>check</mat-icon>
            </div>
            <div
              *ngIf="
                !phoneVerify &&
                profileSetUpFormGroup.get('phoneNo')?.value &&
                !profileSetUpFormGroup
                  .get('phoneNo')
                  ?.hasError('validatePhoneNumber')
              "
              class="only_btn">
              <a (click)="openDialog('phone')">
                {{ 'Verify' | translate }}
              </a>
            </div>
          </div>
        </div>
        <mat-error
          *ngIf="
            submitted &&
            (profileSetUpFormGroup.get('phoneNo')?.value === '' ||
              profileSetUpFormGroup.get('phoneNo')?.value === null) &&
            profileSetUpFormGroup.get('phoneNo')?.hasError('required')
          ">
          {{ 'PhoneNumber' | translate }}
          {{ 'isRequired' | translate }}
        </mat-error>
        <mat-error
          *ngIf="
            submitted &&
            (profileSetUpFormGroup.get('phoneNo')?.value === undefined ||
              profileSetUpFormGroup
                .get('phoneNo')
                ?.hasError('validatePhoneNumber'))
          ">
          {{ 'PleaseEnterValid' | translate }}
          {{ 'PhoneNumber' | translate }}
        </mat-error>

        <!-- <div class="form_group">
          <mat-form-field>
            <input
              #placesRef="ngx-places"
              ngx-google-places-autocomplete
              matInput
              [placeholder]="'address' | translate"
              class="form_control"
              (keydown)="handleKeyDown($event)"
              (onAddressChange)="handleAddressChange($event)"
              formControlName="address" />
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              profileSetUpFormGroup?.get('address')?.hasError('required')
            ">
            {{ 'Address' | translate }}
            {{ 'isRequired' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              submitted &&
              profileSetUpFormGroup.get('address')?.value &&
              (!profileSetUpFormGroup.get('latitude')?.value || !profileSetUpFormGroup.get('longitude')?.value)
            ">
            {{ 'SelectAddressFromPicker' | translate }}
          </mat-error>
        </div> -->

        <div class="submit_btn mt_20">
          <button type="submit" class="btnn btn_primary">
            {{ 'submit' | translate }}
          </button>
        </div>
        <p class="signup_text">
          <a (click)="skipProfileForm()">{{ 'skip' | translate }}</a>
        </p>
      </div>
    </form>
  </div>
</div>
